/* Procraft face lift pass 2: header state, parallax, count-up, the pinned heater, the photo
   gallery and the sticky add-to-cart bar. One scroll listener, one observer, no libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.querySelector('header.site');
  var par = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var anats = Array.prototype.slice.call(document.querySelectorAll('[data-anat]'));
  var narrow = window.matchMedia('(max-width: 860px)');

  /* Count-up, once */
  function countUp(el) {
    var to = parseFloat(el.dataset.count); if (!to || reduce) return;
    var t0 = null; el.textContent = '0';
    function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 1100); el.textContent = String(Math.round(to * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-count]').forEach(function (el) { io.observe(el); });
  }

  /* Scroll: header shadow, parallax, pinned heater progress */
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 10);
    if (!reduce) par.forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var k = parseFloat(el.dataset.parallax) || 0.12;
      el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -k).toFixed(1) + 'px,0)';
    });
    anats.forEach(function (s) {
      if (reduce || narrow.matches) { s.querySelectorAll('[data-step]').forEach(function (li) { li.classList.add('is-on'); }); return; }
      var r = s.getBoundingClientRect(); var span = r.height - vh;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
      s.style.setProperty('--p', p.toFixed(3));
      var steps = s.querySelectorAll('[data-step]'); var n = steps.length;
      steps.forEach(function (li, i) { li.classList.toggle('is-on', p >= (i / n) * 0.92); });
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  window.addEventListener('resize', frame);
  frame();

  /* Gallery: thumbs scroll the track; swiping moves the ring */
  document.querySelectorAll('[data-gal]').forEach(function (g) {
    var track = g.querySelector('[data-gal-track]'); if (!track) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gal-thumb]'));
    function mark(i) { thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); }); }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' }); mark(i); });
    });
    var tm; track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = Math.round(track.scrollLeft / track.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1);
      i = Math.max(0, Math.min(thumbs.length - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); mark(i);
    });
  });

  /* Sticky add to cart: shows once the real button has scrolled away */
  var atc = document.querySelector('[data-atc]');
  var buy = document.querySelector('.pc-buy button[type="submit"]');
  if (atc && buy && 'IntersectionObserver' in window) {
    var go = atc.querySelector('[data-atc-go]');
    new IntersectionObserver(function (es) {
      var e = es[0]; var on = !e.isIntersecting && e.boundingClientRect.top < 0;
      atc.classList.toggle('is-on', on); atc.setAttribute('aria-hidden', on ? 'false' : 'true'); go.tabIndex = on ? 0 : -1;
    }).observe(buy);
    go.addEventListener('click', function () { var f = buy.form; if (f && f.requestSubmit) f.requestSubmit(buy); else buy.click(); });
  }
})();
